export const heading: React.CSSProperties = {
  fontSize: 36, fontWeight: 800, letterSpacing: '-0.02em', marginBottom: 8,
}

export const updated: React.CSSProperties = {
  fontSize: 13, color: '#777', fontFamily: "var(--oe-font-mono)", marginBottom: 40,
  fontWeight: 500,
}

export const h2: React.CSSProperties = {
  fontSize: 22, fontWeight: 800, letterSpacing: '-0.01em', marginTop: 48, marginBottom: 16,
}

export const h3: React.CSSProperties = {
  fontSize: 17, fontWeight: 700, marginTop: 32, marginBottom: 12,
}

export const p: React.CSSProperties = {
  fontSize: 16, lineHeight: 1.8, color: '#4a4745', marginBottom: 16, fontWeight: 500,
}

export const ul: React.CSSProperties = {
  fontSize: 16, lineHeight: 1.8, color: '#4a4745', marginBottom: 16,
  paddingLeft: 24, listStyleType: 'disc', fontWeight: 500,
}

export const li: React.CSSProperties = {
  marginBottom: 8,
}

export const highlight: React.CSSProperties = {
  background: '#FFF5ED', padding: '20px 24px', borderRadius: 12,
  border: '1px solid rgba(255,107,0,0.12)', marginBottom: 16,
  fontSize: 15, lineHeight: 1.7, color: '#1a1216', fontWeight: 500,
}
